export default __webpack_public_path__ + "static/media/FixedInflationExtensionTemplate.9be4c7ad.sol";